import { Box } from "@mui/material";
import classess from "./Spiel.module.css";
import React from "react";

const EN = ({ Item, Type }) => {
  return (
    <Box className={classess.EN}>
      <span>{Type.length === 0 || Type === "" ? Item.EN : Item.GR}</span>
    </Box>
  );
};

export default EN;
